import React, { useMemo } from 'react'

export interface EndTimeProps {
  endTime: number
}

const EndTime: React.FC<EndTimeProps> = ({ endTime }) => {
  const value = useMemo(() => {
    if (!endTime) {
      return '-'
    }

    return new Date(endTime * 1000).toLocaleString(undefined, {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  }, [endTime])

  return <span>{value}</span>
}

export default EndTime
